import { gql } from "@apollo/client";

export const TYPING_SUBSCRIPTION = gql`
  subscription typing {
    typing
  }
`;
